import React, { PureComponent } from "react";
import { Alert, Card, Icon, Select, Spin } from "antd";
import { connect } from "react-redux";
import { withActions, isBusy } from "actionware";
import { getTranslate } from "react-localize-redux";
import * as R from "ramda";
import { isEmpty, isNull } from "lodash";

import Panel from "../../components/panel/panel";
import Section from "../../components/section/section";
import {
  fetchLenderPortfolioV2,
  resetToInitialState as resetLenderPortfolioToInitialState,
} from "../approval/summaryActions.js";
import * as numeral from "numeral";
import { moneyFormat } from "../../common/constants";
import { getLenderId, getRole } from "../../common/helpers";
import { fetchInvestmentDetail } from "./lenderStatisticActions";
import {
  getLendersList,
  toggleErrorCard,
} from "../fundingLimit/fundingLimitActions";
import "../home/home.less";
import DualPanel from "../../components/panel/dualPanel.jsx";
import ErrorCard from "../../components/errorCard/errorCard.jsx";
import { isLenderPortfolioApiEnabled } from "../../common/config";

@connect(
  ({
    localize,
    session,
    lenderStatistic: { investmentDetail, totalLoans, investmentPercentage },
    summary: { portfolioSummary, errorCard },
    funding: { lenders },
  }) => ({
    translate: getTranslate(localize),
    error: false,
    userName: R.pathOr("", ["user", "name"], session),
    totalLoans,
    investmentPercentage,
    investmentDetail,
    lenders,
    portfolioSummary,
    errorCard,
    loading:
      isBusy(getLendersList) ||
      (isEmpty(portfolioSummary) && !errorCard.errorCardVisible),
  })
)
@withActions({
  fetchInvestmentDetail,
  fetchLenderPortfolioV2,
  getLendersList,
  toggleErrorCard,
  resetLenderPortfolioToInitialState,
})
export default class LenderStatistic extends PureComponent {
  constructor(props) {
    super();
    this.state = {
      role: "",
      isAdmin: false,
      lenderID: "allFunds",
    };

    this.handleChange = this.handleChange.bind(this);
  }
  async componentWillMount() {
    if (!isLenderPortfolioApiEnabled()) return;
    const lenderID = await getLenderId(),
      role = await getRole(),
      isAdmin = ["ADMIN"].includes(role);
    this.setState({ role, lenderID, isAdmin });
    let params = {
      lender_id: lenderID,
    };
    if (isAdmin) {
      this.props.getLendersList();
      params = {};
    }

    this.props.fetchLenderPortfolioV2(params);
  }

  async componentDidUpdate() {
    if (!isLenderPortfolioApiEnabled()) return;
    const role = await getRole();
    this.setState({ role });
  }

  retryGetRequest = () => {
    const { lenderID } = this.state;
    this.props.toggleErrorCard({
      api: "",
      flag: false,
    });
    let params = {
      lender_id: lenderID,
    };
    if (lenderID && lenderID === "allFunds") {
      params = {};
    }
    this.props.fetchLenderPortfolioV2(params);
  };

  handleChange = (value) => {
    this.props.resetLenderPortfolioToInitialState();
    let params = {};
    if (value !== "allFunds") {
      params = {
        lender_id: value,
      };
    }
    this.setState({
      lenderID: value,
    });
    this.props.fetchLenderPortfolioV2(params);
  };

  getLenderDropdownList = () => {
    const { Option } = Select;
    const children = [];
    const { lenders, translate } = this.props;
    lenders.map((lender) => {
      return children.push(
        <Option key={lender.lender_id}>{lender.lender_name}</Option>
      );
    });

    children.push(
      <Option key={"allFunds"}>
        {translate("homePage.ovo_admin_home_heading_all_funds")}
      </Option>
    );
    return children;
  };

  renderLenderDropdown = () => {
    const { isAdmin } = this.state,
      lenderList = this.getLenderDropdownList(),
      { translate } = this.props;

    if (isAdmin) {
      return (
        <Select
          disabled={this.props.loading}
          showArrow="true"
          showSearch="false"
          size="large"
          placeholder="All funds"
          className="select-bar-style-container"
          onChange={this.handleChange}
          value={this.state.lenderID}
          menuItemSelectedIcon={<Icon type="check-square" theme="filled" />}
        >
          {lenderList}
        </Select>
      );
    } else {
      return (
        <div className="home-page-title-container">
          {translate("homePage.funds")}
        </div>
      );
    }
  };

  renderLoanAmount = () => {
    const {
      portfolioSummary: {
        loans_pending: { number_of_loans, total_amount },
      },
      translate,
    } = this.props;
    return (
      <Section className={"lender-statistic lender-statistic-section"}>
        <DualPanel
          translate={translate}
          firstTitle={"homePage.ovo_admin_home_label_pending_loan_count"}
          firstValue={number_of_loans}
          secondTitle={"homePage.ovo_admin_home_label_pending_loan_amount"}
          skipFirstValueFormat={true}
          skipSecondValueFormat={false}
          secondValue={total_amount}
        />
      </Section>
    );
  };

  renderOverallFundSummary = () => {
    const { isAdmin } = this.state;
    const {
      portfolioSummary: {
        loans_approved: { number_of_loans, total_amount },
      },
      translate,
      loading,
    } = this.props;
    return (
      <Section className={"lender-statistic"}>
        <Panel
          title={translate(
            "homePage.ovo_admin_home_label_approved_loans_count"
          )}
          loading={loading}
        >
          <h1 className={"loans-breakdown"}>{number_of_loans}</h1>
        </Panel>
        {isAdmin && (
          <Panel
            title={translate(
              "homePage.ovo_admin_home_label_approved_loan_amount"
            )}
          >
            <h1 className={"loans-breakdown"}>
              {total_amount && total_amount !== "-"
                ? numeral(total_amount).format(moneyFormat)
                : total_amount}
            </h1>
          </Panel>
        )}
      </Section>
    );
  };

  renderLoanDisbursedSummary = () => {
    const { portfolioSummary, translate } = this.props;
    return isEmpty(portfolioSummary.loans_approved.products) ? (
      <></>
    ) : (
      <Section
        className={"lender-statistic"}
        title={translate("homePage.ovo_admin_home_heading_loans_disbursed")}
      >
        {portfolioSummary.loans_approved.products.map((product) => {
          return (
            <Panel title={product.product_name}>
              <h1 className={"loans-breakdown"}>
                {numeral(product.total_amount).format(moneyFormat)}
              </h1>
            </Panel>
          );
        })}
      </Section>
    );
  };

  render() {
    if (!isLenderPortfolioApiEnabled()) {
      return <div />;
    }
    const { translate, loading, error, errorCard } = this.props;

    if (loading) {
      return (
        <>
          {this.renderLenderDropdown()}
          <Spin tip={translate("generic.loadingData")} size="large" />
        </>
      );
    }

    if (error) {
      return (
        <Alert
          message={translate("generic.loadingErrorCaption")}
          description={translate("generic.loadingErrorMessage")}
          type="error"
          showIcon
        />
      );
    }

    if (errorCard.errorCardVisible) {
      return (
        <div>
          {this.renderLenderDropdown()}
          <div className="error-card-container">
            <ErrorCard
              title={translate("homePage.heading_something_went_wrong")}
              caption={translate(
                "homePage.mex_lender_body_retry_come_back_error"
              )}
              buttonText={translate("homePage.button_retry")}
              buttonClickHandler={this.retryGetRequest}
            />
          </div>
        </div>
      );
    }

    return (
      <div>
        {this.renderLenderDropdown()}
        {this.renderOverallFundSummary()}
        {this.renderLoanAmount()}
        {this.renderLoanDisbursedSummary()}
      </div>
    );
  }
}
